import * as tslib_1 from "tslib";
import { MovieClip as AwayMovieClip, Sprite as AwaySprite } from "@awayjs/scene";
import { DefaultSceneGraphFactory } from "@awayjs/scene";
import { Sprite } from "../display/Sprite";
import { MovieClip } from "../display/MovieClip";
import { Bitmap } from "../display/Bitmap";
import { BitmapData } from "../display/BitmapData";
import { DisplayObjectContainer } from "../display/DisplayObjectContainer";
import { TextField } from "../text/TextField";
var FlashSceneGraphFactory = (function (_super) {
    tslib_1.__extends(FlashSceneGraphFactory, _super);
    function FlashSceneGraphFactory() {
        var _this = _super.apply(this, arguments) || this;
        _this.imageStore = {};
        return _this;
    }
    FlashSceneGraphFactory.prototype.creatematerial = function () {
        return null;
    };
    FlashSceneGraphFactory.prototype.createSprite = function (prefab, graphics) {
        if (prefab === void 0) { prefab = null; }
        if (graphics === void 0) { graphics = null; }
        return new Sprite(AwaySprite.getNewSprite(graphics)).adaptee;
    };
    FlashSceneGraphFactory.prototype.createDisplayObjectContainer = function () {
        return new DisplayObjectContainer().adaptee;
    };
    FlashSceneGraphFactory.prototype.createMovieClip = function (timeline) {
        if (timeline === void 0) { timeline = null; }
        return new MovieClip(new AwayMovieClip(timeline)).adaptee;
    };
    FlashSceneGraphFactory.prototype.createTextField = function () {
        return new TextField().adaptee;
    };
    FlashSceneGraphFactory.prototype.createBillboard = function (material) {
        return new Bitmap(material.style.image.adapter).adaptee;
    };
    FlashSceneGraphFactory.prototype.createImage2D = function (width, height, transparent, fillColor, powerOfTwo) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        return new BitmapData(width, height, transparent, fillColor).adaptee;
    };
    return FlashSceneGraphFactory;
}(DefaultSceneGraphFactory));
export { FlashSceneGraphFactory };
